
import { importSync as i } from '@embroider/macros';
let d = window.define;
d("dashboard/routes/dashboard/index", function(){ return i("dashboard/routes/dashboard/index.ts");});
